import { Component, Input } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-display-status-restriction',
  standalone: false,
  templateUrl: './display-status-restriction.component.html',
  styleUrl: './display-status-restriction.component.scss',
})
export class DisplayStatusRestrictionComponent {
  @Input() control: FormControl;

  readonly pickerControl = new UntypedFormControl('');

  get selectedStatuses(): string[] {
    return (this.control?.value as string[]) ?? [];
  }

  onAdd(status: string): void {
    const trimmed = status?.trim();
    if (!trimmed) {
      return;
    }
    const current = (this.control.value as string[]) ?? [];
    if (!current.includes(trimmed)) {
      this.control.setValue([...current, trimmed]);
      this.control.markAsDirty();
    }
    this.pickerControl.setValue('', { emitEvent: false });
  }

  onRemove(status: string): void {
    const current = (this.control.value as string[]) ?? [];
    this.control.setValue(current.filter((s) => s !== status));
    this.control.markAsDirty();
  }
}
